import React, { useState } from 'react';
import '../../entrydoor.css';

const WeatherStrip = ({ value, onChange, label = 'Weather Strip' }) => {
    const [selectedWeatherStrip, setSelectedWeatherStrip] = useState(value || "");

    const handleWeatherStripChange = (e) => {
        setSelectedWeatherStrip(e.target.value);
        onChange(e.target.value);
    };

    return (
        <div className="a-container">
            <label htmlFor="WeatherStrip">{label}</label>
            <select
                id="WeatherStrip"
                value={selectedWeatherStrip}
                onChange={handleWeatherStripChange}
            >
                <option value="" disabled hidden>Select an option</option>
                <option value="Foam">{selectedWeatherStrip === "Foam" ? "Foam ✔" : "Foam"}</option>
                <option value="NewWeatherstrippingNowick">{selectedWeatherStrip === "NewWeatherstrippingNowick" ? "New Weatherstripping Nowick ✔" : "New Weatherstripping Nowick"}</option>
            </select>
        </div>
    );
};

export default WeatherStrip;
